// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'speaker-on';

export const Component = () => (
  <path d='M19.716 8.843v6.848c0 .336-.192.527-.527.527s-.479-.191-.479-.527V8.843c0-.335.144-.479.48-.479.334 0 .526.144.526.479Zm2.92-1.964v10.776c0 .335-.143.526-.478.526-.335 0-.48-.191-.48-.526V6.879c0-.335.145-.479.48-.479.335 0 .479.144.479.479ZM15.262 3c.431 0 .766.144 1.054.431.287.288.431.623.431 1.054v15.709c0 .431-.144.766-.431 1.054a1.408 1.408 0 0 1-1.054.43c-.335 0-.67-.095-.91-.334l-5.46-4.598H3.958a.946.946 0 0 1-.67-.287.946.946 0 0 1-.288-.67V8.89c0-.239.096-.479.288-.67a.946.946 0 0 1 .67-.287H8.89l5.459-4.598c.335-.24.67-.335.91-.335Zm.479 17.193V4.484c0-.335-.144-.479-.48-.479-.047 0-.143.048-.334.097l-5.7 4.789H3.96v6.896h5.268l5.746 4.79a.41.41 0 0 0 .288.096c.335 0 .479-.144.479-.48Z' />
);

export const viewBox = '0 0 25 25';
